var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay d-flex justify-content-center align-items-center",style:({backgroundColor: _vm.backgroundColor})},[_c('component-spinner',{staticClass:"p-5",attrs:{"type":"spinner-grow"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }